import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { stickyCtaBar as orgConfig } from 'org/configs/modules.config';

/** @type {object} */
const defaultConfig = {
  defaults: {
    topOffsetSelector: '.mn_pageHeader',
    bottomOffsetSelector: '.mn_brandFooter',
    useStickyBehaviorOnMediaQueriesOnly: ['M', 'L', 'XL', 'XXL'],
    viewOptions: {
      title: 'Turn your shopping into more miles today',
      buttonLanguage: 'Sign in',
    },
    urlLink: '',
    urlTitle: '',
    useRegistrationLink: false,
  },
  hiw: {
    topOffsetSelector: '.mn_hiwPrimaryHero',
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
